import cn from 'classnames'
import { FC } from 'react'

import { RichTextEditor } from 'core-components/library/richTextEditor'
import { Tooltip } from 'core-components/library/tooltip'

import { useFormField } from '../../hooks/useFormField'
import { ReadOnlyField } from '../readOnlyField'

import { IFormRichTextEditor } from './models'

import styles from './FormRIchTextEditor.module.scss'

export const FormRichTextEditor: FC<IFormRichTextEditor> = ({
  field,
  formKey,
  label,
  defaultValue,
  className,
  toolbarButtonsView,
  toolbarCustomButtons,
  toolbarClassName,
  isDisabled,
  isRequired,
  isReadOnly,
  isVisible = true,
  onChange,
  onBlur,
  onValidate,
  validationType,
}) => {
  const { value, validationMessage, handleChange, handleBlur } = useFormField({
    field,
    formKey,
    defaultValue,
    onChange,
    onValidate,
    isDisabled,
    isRequired,
    isReadOnly,
    isVisible,
    onBlur,
    validationType,
  })

  if (isVisible) {
    if (isReadOnly) {
      return <ReadOnlyField label={label} value={value} />
    }

    return (
      <div className={styles.validationContainer}>
        <Tooltip disabled={!validationMessage} tipContent={() => <>{validationMessage}</>}>
          <RichTextEditor
            classes={{
              root: cn(className),
              toolbar: toolbarClassName,
            }}
            toolbarButtonsView={toolbarButtonsView}
            toolbarCustomButtons={toolbarCustomButtons}
            value={value}
            onInputFinished={handleBlur}
            onChange={handleChange}
            disabled={isDisabled}
          />
        </Tooltip>
      </div>
    )
  }

  return null
}
